function snakeCaseFilter() {
    'ngInject';

    return string => string.trim().replace(/\s/g, '_').toLowerCase();
}

angular
    .module('BB')
    .filter('snakeCase', snakeCaseFilter);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_filters/snake_case.filter.js